/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import SoftBadge from 'components/common/SoftBadge';

const NavbarVerticalMenuItem2 = ({ route }) => {
  return (
<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between',paddingRight:'15px',paddingTop:'5px',paddingBottom:'5px' }}>
  <div style={{ display: 'flex', alignItems: 'center' }}>
    {route.icon && (
      <span className="nav-link-icon">
        <FontAwesomeIcon icon={route.icon} />
      </span>
    )}
    <span className="nav-link-text ps-1">{route.name}</span>
  </div>
  {route.badge && (
    <SoftBadge pill bg="dark">
      {route.badge.text}
    </SoftBadge>
  )}
</div>
  
  );
};

// prop-types
const routeShape = {
  active: PropTypes.bool,
  name: PropTypes.string.isRequired,
  to: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.array, PropTypes.string])
};
routeShape.children = PropTypes.arrayOf(PropTypes.shape(routeShape));
NavbarVerticalMenuItem2.propTypes = {
  route: PropTypes.shape(routeShape).isRequired
};

export default React.memo(NavbarVerticalMenuItem2);
/* eslint-disable */